import { useState, useCallback, useEffect, type ChangeEvent } from 'react';
import { StoreSettings } from '../Types/StoreTypes';

export const useThemeSettings = (Currentsettings: StoreSettings, SettingsActions: any) => {
    const [imagePreviewDark, setImagePreviewDark] = useState<string | null>(null);
    const [imagePreviewLight, setImagePreviewLight] = useState<string | null>(null);

    const handleImageChange = useCallback(
        (e: ChangeEvent<HTMLInputElement>, themeColor: string) => {
            if (e.target.files && e.target.files[0]) {
                const file = e.target.files[0];

                if (themeColor === 'light') {
                    SettingsActions.setCurrentSettings((prev: any) => {
                        return {
                            ...prev,
                            theme: { ...prev.theme, lightThemeImage: file },
                        };
                    });
                } else {
                    SettingsActions.setCurrentSettings((prev: any) => {
                        return {
                            ...prev,
                            theme: { ...prev.theme, darkThemeImage: file },
                        };
                    });
                }
            }
        },

        [SettingsActions],
    );

    const handleRemoveImage = useCallback(
        (themeColor: string) => {
            if (themeColor === 'light') {
                SettingsActions.setCurrentSettings((prev: any) => {
                    return {
                        ...prev,
                        theme: { ...prev.theme, lightThemeImage: null },
                    };
                });
            } else {
                SettingsActions.setCurrentSettings((prev: any) => {
                    return {
                        ...prev,
                        theme: { ...prev.theme, darkThemeImage: null },
                    };
                });
            }
        },
        [SettingsActions],
    );

    const lightThemeImage = Currentsettings?.theme?.lightThemeImage;
    const darkThemeImage = Currentsettings?.theme?.darkThemeImage;

    useEffect(() => {
        if (!lightThemeImage) {
            setImagePreviewLight(null);
            return;
        }

        if (typeof lightThemeImage === 'string') {
            setImagePreviewLight(lightThemeImage);
            return;
        }

        const objectUrl = URL.createObjectURL(lightThemeImage);
        setImagePreviewLight(objectUrl);
        return () => URL.revokeObjectURL(objectUrl);
    }, [lightThemeImage]);

    useEffect(() => {
        if (!darkThemeImage) {
            setImagePreviewDark(null);
            return;
        }

        if (typeof darkThemeImage === 'string') {
            setImagePreviewDark(darkThemeImage);
            return;
        }

        const objectUrl = URL.createObjectURL(darkThemeImage);
        setImagePreviewDark(objectUrl);
        return () => URL.revokeObjectURL(objectUrl);
    }, [darkThemeImage]);

    return {
        setImagePreviewDark,
        setImagePreviewLight,
        handleImageChange,
        handleRemoveImage,
        imagePreviewDark,
        imagePreviewLight,
    };
};
